// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3F82M","rootMobile":"styles_rootMobile__afHU6"};